import { AutoComplete, Button, GroupInput, Input, Select } from '@/components';
import { memo, useCallback } from 'react';

import { Space } from 'antd';

import { IInputTarget } from './input-target';

export interface IInputTargetMobile extends IInputTarget {
	onSearch?: () => void;
}

const InputTargetMobile = ({
	formik,
	label,
	name,
	labelClassName,
	inputProps,
	dropdownProps,
	autoCompleteProps,
	searchTypeConfigs = [],
	onSearch,
	...props
}: IInputTargetMobile) => {
	const handleChangeSelect = useCallback(
		(value: string) => {
			formik.setValues((prev) => ({
				...prev,
				[name]: {
					...prev[name],
					searchType: value,
					searchValue: '',
				},
			}));
		},
		[formik, name]
	);

	const handleChangeSearchValue = useCallback(
		(value: string) => {
			formik.setValues((prev) => ({
				...prev,
				[name]: {
					...prev[name],
					searchValue: value,
				},
			}));
		},
		[formik, name]
	);

	const handleInputChange = useCallback(
		(e: React.ChangeEvent<HTMLInputElement>) => {
			handleChangeSearchValue(e.target.value);
		},
		[handleChangeSearchValue]
	);

	const handleKeyDown = useCallback(
		(e: React.KeyboardEvent) => {
			if (e.key === 'Enter') {
				onSearch?.();
			}
		},
		[onSearch]
	);

	const renderSearchInput = useCallback(() => {
		const currentSearchType = formik.values[name]?.searchType;
		const searchTypeConfig = searchTypeConfigs.find(
			(config) => config.value === currentSearchType
		);

		const commonProps = {
			className: 'gap-0',
			inputClassName: '!w-full !h-[40px]',
			value: formik.values[name]?.searchValue || '',
		};

		if (searchTypeConfig?.inputType === 'autocomplete') {
			return (
				<AutoComplete
					{...commonProps}
					{...autoCompleteProps}
					options={autoCompleteProps?.options}
					searchValue={commonProps.value}
					onChange={handleChangeSearchValue}
					onSelect={onSearch}
					onKeyDown={handleKeyDown}
				/>
			);
		}

		return (
			<Input
				{...commonProps}
				{...inputProps}
				name={name}
				onChange={handleInputChange}
				onPressEnter={onSearch}
			/>
		);
	}, [
		formik.values,
		name,
		searchTypeConfigs,
		autoCompleteProps,
		inputProps,
		handleChangeSearchValue,
		handleInputChange,
		handleKeyDown,
		onSearch,
	]);

	return (
		<GroupInput label={label} labelClassName={labelClassName}>
			<div className="flex gap-[8px] md:gap-[12px] w-full">
				<Select
					className="!w-[30.833vw] !h-[40px]"
					{...dropdownProps}
					name={name}
					value={formik.values[name]?.searchType}
					onChange={handleChangeSelect}
				/>
				<Space.Compact className="!w-[calc(100%-30.833vw)]">
					{renderSearchInput()}
					<Button
						className="min-w-[60px] w-[60px] h-[40px] text-[16px] bg-cornflower !border-cornflower hover:!bg-cornflower hover:!text-white rounded-none rounded-tr-[5px] rounded-br-[5px] text-white"
						onClick={onSearch}
					>
						검색
					</Button>
				</Space.Compact>
			</div>
		</GroupInput>
	);
};

export default memo(InputTargetMobile);
